import React, { useEffect, useState } from "react";
import axios from "../../axios";
import { Line } from "@reactchartjs/react-chart.js";
import moment from "moment";
import { useSelector } from "react-redux";
import { currentCurrency } from "../../features/currencySlice";

function CoinChart({ coinId, interval, positive }) {
  const [history, setHistory] = useState([]);
  const currentCurSelected = useSelector(currentCurrency);

  const intervalCalDict = {
    "1D": [24, "m5"],
    "1W": [24 * 7, "m30"],
    "1M": [24 * 30, "h2"],
    "3M": [24 * 30 * 3, "h6"],
    "6M": [24 * 30 * 6, "h12"],
    "1Y": [24 * 30 * 12, "d1"],
    ALL: [24 * 30 * 12, "d1"],
  };

  const options = {
    maintainAspectRatio: true,
    responsive: true,
    zoomEnabled: true,
    animationEnabled: true,
    legend: false,

    scales: {
      xAxes: [
        {
          type: "time",
          distribution: "linear",
          gridLines: {
            display: false,
          },
        },
      ],
      yAxes: [
        {
          position: "right",
        },
      ],
    },
  };

  useEffect(() => {
    const endTimestamp = new Date().getTime();
    const startTimestamp =
      endTimestamp - intervalCalDict[interval][0] * 3600 * 1000;
    const url =
      interval === "ALL"
        ? `/assets/${coinId}/history?interval=${intervalCalDict[interval][1]}`
        : `/assets/${coinId}/history?interval=${intervalCalDict[interval][1]}&start=${startTimestamp}&end=${endTimestamp}`;
    axios.get(url).then((res) => {
      setHistory(res.data.data);
    });
  }, [coinId, interval]);

  const prices = history.map(
    (single) =>
      parseFloat(single.priceUsd) / parseFloat(currentCurSelected.rateUsd)
  );
  const time = history.map((single) => parseInt(single.time));

  const data = {
    labels: time,
    datasets: [
      {
        label: "Price",
        data: prices,
        fill: true,
        lineTension: 0.1,
        backgroundColor: positive
          ? "rgba(244, 67, 54, 0.4)"
          : "rgba(24, 198, 131, 0.4)",
        borderColor: positive ? "rgb(244, 67, 54)" : "rgb(24, 198, 131)",
        borderCapStyle: "butt",
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: "miter",
        pointBorderColor: positive ? "rgb(244, 67, 54)" : "rgb(24, 198, 131)",
        pointBackgroundColor: "#fff",
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: positive
          ? "rgb(244, 67, 54)"
          : "rgb(24, 198, 131)",
        pointHoverBorderColor: "rgba(220,220,220,1)",
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
      },
    ],
  };

  return <Line data={data} options={options} />;
}

export default CoinChart;
